import ModelState from 'spa/state/_util/model';

class UserSubscriptions extends ModelState {
  get url() { return '/me/subscriptions'; }
  get method() { return 'GET'; }
  get singular() { return 'subscription'; }
  get plural() { return 'subscriptions'; }
}

export default UserSubscriptions;



// WEBPACK FOOTER //
// ./spa/state/user/user-subscriptions.jsx